import React, { useState } from "react";
// import { useNavigate } from "react-router-dom";
import { Col, Row } from "reactstrap";
import styled from "styled-components";
import "./index.css";
import { Popover, PopoverBody } from "reactstrap";
import StudentProfile from "Assets/Images/StudentProfile.svg";
import ReportStudentIcon from "Assets/Icons/ReportStudentIcon";
import Typography from "Components/CommonComponents/Typography";
import { Tooltip } from "antd";

const ProfileImageDiv = styled<any>("div")`
      display:flex;
      flex-direction: column;
      padding-right ${(props: any) =>
        ["xxl", "xl", "lg"].includes(props.screen) ? "24px" : "16px"};
`;
const NameDiv = styled<any>("div")`
    font-size ${(props: any) =>
      ["xxl", "xl", "g"].includes(props.screen)
        ? props.mode && props.mode == "attendance"
          ? "16px"
          : "20px"
        : "14px"};
    color: ${(props: any) => (props.isEnabled ? "#333" : "#008DC4")};
    cursor: ${(props: any) =>
      props.mode && props.mode == "attendance" ? "pointer" : "auto"};
    font-style: normal;
    font-weight: 600;
    line-height: 28px; 
    display: flex;
    flex-direction: row;
`;
const BasicInfoDiv = styled<any>("div")`
      font-size ${(props: any) =>
        ["xxl", "xl", "g"].includes(props.screen)
          ? props.mode && props.mode == "attendance"
            ? "14px"
            : "16px"
          : "12px"};
      color: var(--Grey-60, #757575);
      font-style: normal;
      font-weight: 400;
      line-height: 24px; /* 150% */
      padding-bottom: ${(props: any) => (props.isTop ? "4px" : "0px")};
`;
const BasicInfoDiv2 = styled<any>("div")`
padding-top: ${(props: any) =>
  ["xxl", "xl", "lg"].includes(props.screen) ? "0px" : "0px"};
      display:flex;
      flex-direction ${(props: any) =>
        ["xxl", "xl", "lg"].includes(props.screen) ? "row" : "column"};
      align-items: ${(props: any) =>
        ["xxl", "xl", "lg"].includes(props.screen) ? "center" : "flex-start"};
`;
const AttendanceDot = styled.span<{ status: number | null; isFirst?: boolean }>`
  display: inline-block;
  width: 10px;
  height: 10px;
  margin-left: 4px;
  margin-right: ${({ isFirst }) => (isFirst ? "5px" : "3px")};
  border-radius: 50%;
  background: ${({ status }) =>
    status === 1
      ? "#4CAF50" // green
      : status === 0
      ? "#F44336" // red
      : "#BDBDBD"}; // gray
  border: 1px solid #fff;
  ${({ isFirst, status }) =>
    isFirst &&
    `
      outline: 2px solid ${
        status === 1 ? "#4CAF50" : status === 0 ? "#F44336" : "#BDBDBD"
      };
      outline-offset: 1px;
    `}
`;
const AttendanceCardView = (props: any) => {
  const { cardData, screen, handleStudentStatus, handleDeleteStudentStatus } =
    props;
  const [zoomed, setZoomed] = useState<any>(false);
  const [popoverOpen, setPopoverOpen] = useState<boolean>(false);
  const [popoverContent, setPopoverContent] = useState<any>([]);
  // const navigate = useNavigate();

  const selectStudentDetailHandler = (val: any) => {
    // navigate("/admin/performance/" + val.psid, {
    //   replace: false,
    //   state: {
    //     selectedStudent: val,
    //     studentTab: 3,
    //   },
    // });
    window.open(`/admin/performance/${val.psid}`, "_blank");
  };

  const handleClick = () => {
    setZoomed(true);
    setTimeout(() => {
      setZoomed(false);
    }, 1000);
  };
  const closePopover = () => {
    setPopoverContent(null);
    setPopoverOpen(false);
  };
  const handleMouseEnter = (content: any) => {
    setPopoverContent(content);
    setPopoverOpen(!popoverOpen);
  };
  const selectedStudent = cardData;
  const tooltipItem = (selectedStudent: any) => {
    return (
      <Tooltip
        title={
          <span>
            Student&apos;s attendance for the last 10 lectures (left = most
            recent)
            <div
              style={{ display: "flex", alignItems: "center", marginTop: 1 }}
            >
              <span
                style={{
                  display: "inline-block",
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  background: "#4CAF50",
                  border: "1px solid #fff",
                  marginRight: 4,
                  verticalAlign: "middle",
                }}
              ></span>
              Present,&nbsp;
              <span
                style={{
                  display: "inline-block",
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  background: "#F44336",
                  border: "1px solid #fff",
                  marginRight: 4,
                  verticalAlign: "middle",
                }}
              ></span>
              Absent,&nbsp;
              <span
                style={{
                  display: "inline-block",
                  width: 10,
                  height: 10,
                  borderRadius: "50%",
                  background: "#BDBDBD",
                  border: "1px solid #fff",
                  marginRight: 4,
                  verticalAlign: "middle",
                }}
              ></span>
              No data.
            </div>
          </span>
        }
      >
        <div className="d-flex flex-row align-items-center mt-n1">
          <Typography
            variant={
              ["xxl", "xl", "lg"].includes(screen) ? "body3" : "forminfo"
            }
            color="gray"
          >
            Recent:&nbsp;
          </Typography>
          {selectedStudent.pastDaysRecord.map(
            (status: number | null, idx: number) => (
              <AttendanceDot key={idx} status={status} isFirst={idx === 0} />
            )
          )}
        </div>
      </Tooltip>
    );
  };
  return (
    <>
      <Row className="w-100">
        <Col xs={4} sm={4} md={7} lg={7}>
          <div className="d-flex flex-row w-100 h-100 align-items-center">
            <ProfileImageDiv screen={screen}>
              <img
                className={
                  ["xxl", "xl", "lg"].includes(screen)
                    ? "profileImageAttendance"
                    : `profileImageAttendanceMB ${zoomed ? "zoomed" : ""}`
                }
                onClick={handleClick}
                id="selected-image"
                src={
                  selectedStudent?.photoKey
                    ? selectedStudent?.photoKey
                    : StudentProfile
                }
                onError={(event: any) => {
                  event.target.src = StudentProfile;
                  event.onerror = null;
                }}
              />
            </ProfileImageDiv>
            {["xxl", "xl", "lg", "md"].includes(screen) && (
              <div className="d-flex justify-content-start gap-2">
                <NameDiv
                  screen={screen}
                  mode={"attendance"}
                  onClick={() => {
                    selectStudentDetailHandler &&
                      selectStudentDetailHandler(selectedStudent);
                  }}
                >
                  {selectedStudent?.serialNumber
                    ? selectedStudent?.serialNumber + "."
                    : "-"}
                </NameDiv>
                <div className="d-flex flex-column">
                  <NameDiv
                    screen={screen}
                    mode={"attendance"}
                    onClick={() => {
                      selectStudentDetailHandler &&
                        selectStudentDetailHandler(selectedStudent);
                    }}
                  >
                    {selectedStudent?.studentName
                      ? selectedStudent?.studentName
                      : "--"}
                    {selectedStudent?.hasFlag && (
                      <>
                        <div
                          id={
                            "reportStudentpopover" +
                            selectedStudent?.serialNumber
                          }
                          className="reportStudenticonstyleContainer"
                          onClick={(e: any) => e.preventDefault()}
                          onMouseEnter={() => {
                            handleMouseEnter(
                              "Please ask this student to connect with Branch Manager"
                            );
                          }}
                          onMouseLeave={closePopover}
                        >
                          Issue
                          <ReportStudentIcon
                            onClick={(e: any) => e.preventDefault()}
                          />
                        </div>
                        <Popover
                          placement="bottom"
                          isOpen={popoverOpen}
                          target={
                            "reportStudentpopover" +
                            selectedStudent?.serialNumber
                          }
                          toggle={closePopover}
                        >
                          <PopoverBody className="FacultyTablePopover">
                            <div
                              key={"reportStudentpopover"}
                              className="markedLectureCountStyle d-flex flex-column justify-content-start mb-2"
                            >
                              <div className="d-flex flex-column align-items-start justify-content-start w-100">
                                <div className="reportStudenticonstyleContainer reportStudenticonstylePopover">
                                  Issue Found
                                  <ReportStudentIcon />
                                </div>
                                <Typography variant="body3" color="black">
                                  {popoverContent} &nbsp;
                                </Typography>
                              </div>
                            </div>
                          </PopoverBody>
                        </Popover>
                      </>
                    )}
                  </NameDiv>
                  <BasicInfoDiv2 screen={screen}>
                    <BasicInfoDiv
                      screen={screen}
                      isTop={true}
                      mode={"attendance"}
                    >
                      PSID: {selectedStudent?.psid || "NA"} &nbsp;| &nbsp;
                    </BasicInfoDiv>
                    {Array.isArray(selectedStudent?.pastDaysRecord) &&
                      tooltipItem(selectedStudent)}
                  </BasicInfoDiv2>
                </div>
              </div>
            )}
          </div>
        </Col>
        <Col
          xs={8}
          sm={8}
          md={5}
          lg={5}
          className="d-flex justify-content-end align-items-center "
        >
          <Row>
            <Col xs={12} sm={12} md={4} lg={4}>
              {!["xxl", "xl", "lg", "md"].includes(screen) && (
                <div className="d-flex flex-row">
                  <div className="d-flex flex-column justify-content-start">
                    <NameDiv
                      screen={screen}
                      mode={"attendance"}
                      onClick={() => {
                        selectStudentDetailHandler &&
                          selectStudentDetailHandler(selectedStudent);
                      }}
                    >
                      {`${selectedStudent?.serialNumber}. ${selectedStudent?.studentName}`}
                      {selectedStudent?.hasFlag && (
                        <>
                          <div
                            id={
                              "reportStudentpopover" +
                              selectedStudent?.serialNumber
                            }
                            className="reportStudenticonstyleContainer"
                            onClick={(e: any) => e.preventDefault()}
                            onMouseEnter={() => {
                              handleMouseEnter(
                                "Please ask this student to connect with Branch Manager"
                              );
                            }}
                            onMouseLeave={closePopover}
                          >
                            Issue
                            <ReportStudentIcon
                              onClick={(e: any) => e.preventDefault()}
                            />
                          </div>
                          <Popover
                            placement="bottom"
                            isOpen={popoverOpen}
                            target={
                              "reportStudentpopover" +
                              selectedStudent?.serialNumber
                            }
                            toggle={closePopover}
                          >
                            <PopoverBody className="FacultyTablePopover">
                              <div
                                key={"reportStudentpopover"}
                                className="markedLectureCountStyle d-flex flex-column justify-content-start mb-2"
                              >
                                <div className="d-flex flex-column align-items-start justify-content-start w-100">
                                  <div className="reportStudenticonstyleContainer reportStudenticonstylePopover">
                                    Issue Found
                                    <ReportStudentIcon />
                                  </div>
                                  <Typography variant="body3" color="black">
                                    {popoverContent} &nbsp;
                                  </Typography>
                                </div>
                              </div>
                            </PopoverBody>
                          </Popover>
                        </>
                      )}
                    </NameDiv>
                    <div className="d-flex flex-row align-items-center"></div>

                    <BasicInfoDiv2 screen={screen}>
                      <BasicInfoDiv
                        screen={screen}
                        isTop={true}
                        mode={"attendance"}
                      >
                        PSID: {selectedStudent?.psid || "NA"}
                      </BasicInfoDiv>
                      {Array.isArray(selectedStudent?.pastDaysRecord) &&
                        tooltipItem(selectedStudent)}
                    </BasicInfoDiv2>
                  </div>
                </div>
              )}
            </Col>
            <Col xs={12} sm={12} md={8} lg={8}>
              <div
                className={
                  ["xxl", "xl", "lg", "md"].includes(screen)
                    ? "h-100 d-flex flex-row justify-content-end align-items-center"
                    : "h-100 d-flex flex-row justify-content-start align-items-center mt-1"
                }
              >
                <button
                  type="button"
                  disabled={selectedStudent.hasFlag ? true : false}
                  className={
                    cardData.attendanceType == "A"
                      ? "btn btn-custom-small custom-present-btn"
                      : "btn btn-custom-small prsent-hover-button btn-outline-aeslDraft"
                  }
                  onClick={() => {
                    handleStudentStatus(cardData, "A");
                  }}
                >
                  {["xxl", "xl", "lg"].includes(screen) ? "Present" : "P"}
                </button>

                <button
                  type="button"
                  disabled={selectedStudent.hasFlag ? true : false}
                  className={
                    cardData.attendanceType == "O"
                      ? "btn btn-custom-small custom-online-btn"
                      : "btn btn-custom-small online-hover-button btn-outline-aeslDraft"
                  }
                  onClick={() => {
                    handleStudentStatus(cardData, "O");
                  }}
                >
                  {["xxl", "xl", "lg"].includes(screen) ? "Online" : "O"}
                </button>
                {selectedStudent?.isLopStudent ? null : (
                  <button
                    type="button"
                    // disabled={
                    //   onlineStudentList.includes(selectedStudent?.psid)
                    //     ? true
                    //     : false
                    // }
                    className={
                      selectedStudent.hasFlag
                        ? "btn btn-custom-small absent-hover-button btn-outline-aeslDraft"
                        : cardData.attendanceType == "UA"
                        ? "btn btn-custom-small custom-absent-btn"
                        : "btn btn-custom-small absent-hover-button btn-outline-aeslDraft"
                    }
                    onClick={() => {
                      selectedStudent.hasFlag
                        ? handleDeleteStudentStatus(cardData, "D")
                        : handleStudentStatus(cardData, "UA");
                    }}
                  >
                    {["xxl", "xl", "lg"].includes(screen)
                      ? selectedStudent.hasFlag
                        ? "Delete"
                        : "Absent"
                      : selectedStudent.hasFlag
                      ? "D"
                      : "A"}
                  </button>
                )}
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};
export default AttendanceCardView;
